export default {
  title: "SORU9",
  text: `Avustralya'da yaşayan Rebecca isimli bir kadın, dünyada sadece 80 kişide görülen "süper otobiyografik hafıza"ya sahip. Rebecca, bugüne kadar yaşadığı en önem siz olayları bile gayet net hatırlayabiliyor. Çocukken okuduğu kitapların hemen hepsini cümlesi cümlesine ezbere anlatabiliyor. Çoğu insanın gıpta edebileceği bu yetenek, sonradan olumsuz bir duruma dönüşebiliyor. Yeni şeyler öğrenme konusunda zaman zaman güçlükler çeken Rebecca, hatıralarıyla baş etmekte zorlanıyor. Bu özel durum, yeni öğrenmelere yer açan unutmanın ne kadar güzel olduğunu gösteriyor.`
};



// WEBPACK FOOTER //
// ./src/assets/goz-ritim/lgs/9.js